<template>
  <el-dialog title="新的朋友" :visible.sync="show" width="500px" :before-close="close">
    <el-scrollbar style="height: 440px;">
      <div v-if="!requests.length" class="empty-tip">暂无新的好友申请</div>
      <div v-for="req in requests" :key="req.id" class="req-item">
        <head-image :size="40" :name="req.nickName" :url="req.headImage" :is-show-user-info="false"></head-image>
        <div class="req-info">
          <div class="req-name">{{ req.nickName }}</div>
          <div class="req-msg">{{ req.message || '请求添加你为好友' }}</div>
        </div>
        <div class="req-actions">
          <template v-if="req.status === 0 && !isMine(req)">
            <el-button size="mini" type="primary" @click="handle(req, 1)">同意</el-button>
            <el-button size="mini" type="danger" plain @click="handle(req, 2)">拒绝</el-button>
          </template>
          <span v-else class="req-status" :class="statusClass(req)">{{ statusText(req) }}</span>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "newFriend",
  components: { HeadImage },
  data() {
    return {
      show: false,
      requests: []
    }
  },
  methods: {
    open() {
      this.show = true;
      this.loadRequests();
    },
    close() {
      this.show = false;
    },
    isMine(req) {
      // 当前用户是申请人，则是"我发出的"
      return req.fromId === this.userStore.userInfo.id;
    },
    statusText(req) {
      if (this.isMine(req)) {
        // 我发出的申请
        if (req.status === 0) return '等待验证';
        if (req.status === 1) return '已添加';
        if (req.status === 2) return '已拒绝';
        return '已过期';
      }
      // 我收到的申请
      if (req.status === 0) return '待处理';
      if (req.status === 1) return '已添加';
      if (req.status === 2) return '已拒绝';
      return '已过期';
    },
    statusClass(req) {
      if (req.status === 1) return 'status-done';
      if (req.status === 2) return 'status-reject';
      if (req.status === 3) return 'status-expired';
      return 'status-wait';
    },
    loadRequests() {
      this.$http({
        url: "/friend/request/records",
        method: "get"
      }).then((data) => {
        this.requests = data || [];
      })
    },
    handle(req, status) {
      this.$http({
        url: "/friend/request/handle",
        method: "put",
        data: {
          requestId: req.id,
          status: status
        }
      }).then(() => {
        this.$message.success(status == 1 ? '已同意' : '已拒绝');
        if (status == 1) {
          // 同意后刷新好友列表
          this.friendStore.pullFriends();
        }
        this.loadRequests();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-tip {
  text-align: center;
  color: #999;
  padding: 60px 0;
}
.req-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 4px;
  border-bottom: 1px solid #f0f0f0;

  .req-info {
    flex: 1;
    overflow: hidden;

    .req-name {
      font-weight: 600;
      font-size: 14px;
    }
    .req-msg {
      font-size: 12px;
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .req-actions {
    display: flex;
    gap: 4px;
    align-items: center;

    .req-status {
      font-size: 13px;
      color: #999;
      padding: 0 8px;
      white-space: nowrap;

      &.status-done {
        color: #67c23a;
      }
      &.status-reject {
        color: #f56c6c;
      }
      &.status-expired {
        color: #c0c4cc;
      }
      &.status-wait {
        color: #e6a23c;
      }
    }
  }
}
</style>
